import React from 'react';

const LoadingSpinner = ({ message = "Caricamento Escursione..." }) => {
  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
      <p style={{ marginTop: '10px', fontWeight: 'bold' }}>{message}</p>
    </div>
  )
}

export default LoadingSpinner
